export enum FreeTrialDuration {
	Day = "day",
	Month = "month",
	Year = "year",
}
